module.exports = __webpack_public_path__ + "img/input-check-default.1d19f1bc.svg";